import React from 'react'
import { withStyles } from '@material-ui/core/styles'
import { withTranslate } from 'react-redux-multilingual'
import Card from '@material-ui/core/Card'
import CardHeader from '@material-ui/core/CardHeader'
import CardContent from '@material-ui/core/CardContent'
import CardActions from '@material-ui/core/CardActions'
import TextField from '@material-ui/core/TextField'
import Button from '@material-ui/core/Button'
import Fab from '@material-ui/core/Fab'
import ExpandMoreIcon from '@material-ui/icons/NavigateNext'

function LocatorInputCard({
  classes,
  translate,
  reservationId,
  error,
  errorText,
  showFindPropertyLink,
  onChangeReservationId,
  onKeyPress,
  onSubmit,
  onClickFindProperty
}) {
  return (
    <Card className={classes.card} raised>
      <CardHeader title="Checkin" subheader={translate('homeSubHeader')} />
      <CardContent>
        <TextField
          error={error}
          id="reservationId"
          label={translate('localizadorLabel')}
          className={classes.textField}
          value={reservationId}
          helperText={errorText}
          onChange={onChangeReservationId}
          margin="normal"
          onKeyPress={onKeyPress}
          inputProps={{ maxLength: 15 }}
        />
      </CardContent>
      <CardActions className={classes.actions}>
        <Fab
          variant="extended"
          aria-label="Seguindo"
          className={classes.fab}
          onClick={onSubmit}
        >
          <ExpandMoreIcon className={classes.extendedIcon} />
          {translate('nextLabel')}
        </Fab>
      </CardActions>
      {showFindPropertyLink && (
        <p className={classes.orClH}>
          {translate('or')}{' '}
          <Button
            className={classes.orClHLnk}
            style={{ backgroundColor: 'transparent' }}
            onClick={onClickFindProperty}
          >
            {translate('clickHere')}
          </Button>{' '}
          {translate('andSearchForYourData')}
        </p>
      )}
    </Card>
  )
}

const styles = (theme) => ({
  card: {
    maxWidth: 800,
    marginTop: theme.spacing(3),
    marginBottom: theme.spacing(3),
    padding: theme.spacing(2),
    [theme.breakpoints.up(800 + theme.spacing(6))]: {
      marginTop: theme.spacing(6),
      marginBottom: theme.spacing(6),
      padding: theme.spacing(3)
    }
  },
  textField: {
    marginTop: 0,
    marginLeft: 0,
    marginRight: theme.spacing(1),
    width: '100%'
  },
  actions: {
    display: 'flex',
    padding: '16px'
  },
  fab: {
    margin: theme.spacing(1),
    marginLeft: 0
  },
  extendedIcon: {
    marginRight: theme.spacing(1)
  },
  orClH: {
    padding: '0 16px',
    color: 'rgba(0, 0, 0, 0.54)'
  },
  orClHLnk: {
    textDecoration: 'none',
    color: '#303e46',
    cursor: 'pointer',
    textTransform: 'uppercase',
    background: 'none',
    padding: 0
  }
})

export default withStyles(styles)(withTranslate(LocatorInputCard))
